import React from "react";

function OTPTextField(props) {
  const onClickHandler = (event) => {
    props.resendOtp();
  };

  const onBlurHandler = (event) => {
    props.verifyOtp(event.target.value);
  };

  return (
    <div className={`ui input ${props.className}`}>
      <button
        className={`resend-otp-button ${
          props.showLoader
            ? "spinner-border absolute-position-loader"
            : "absolute-position"
        }`}
        onClick={onClickHandler}
      >
        {!props.showLoader && "Resend"}
      </button>
      <input
        onBlur={onBlurHandler}
        onChange={() => {
          props.onChange();
        }}
        type="text"
        autoComplete="one-time-code"
        placeholder="OTP Number"
      />
    </div>
  );
}

export default OTPTextField;
